import React, { useEffect } from 'react' 

import { useLocation } from 'react-router-dom'

const OnPageChange = () => {
    const { pathname } = useLocation();

   useEffect(() => {
		// Active Campaign (vgo) was replaced by HubSpot; only call if still present
		if (typeof window.vgo === 'function') {
			window.vgo('update');
			window.vgo('process');
		}
   },[pathname])

   return ( 
      null
   ) 
}


export default OnPageChange